const types = {
  SET_ARTICLE_LIST_LOADING: "SET_ARTICLE_LIST_LOADING",
  SET_ARTICLE_LIST: "SET_ARTICLE_LIST",
  SET_VIEW_ARTICLE_LOADING: "SET_VIEW_ARTICLE_LOADING",
  SET_VIEW_ARTICLE: "SET_VIEW_ARTICLE",
  // TODO(VER-563 follow-up): SET_CASE_CATEGORY_ID has no producer — only ever
  // dispatched with no argument from ArticleList.jsx (clearing the value).
  // Either wire up a real dispatcher or rip the plumbing out (this type, the
  // setCaseCategoryId action, the reducer case, and all caseCategoryId
  // references in ArticleList.jsx).
  SET_CASE_CATEGORY_ID: "SET_CASE_CATEGORY_ID",
};

export default types;
